/**
 * React Router loader to fetch any submittal pre-requisite data.
 * Usage: export in your route object as the loader.
 *
 * Expects a route param `jobId`
 * Returns the data that can be used in child/nested routes.
 */

import { loginRequest } from 'auth/config/authConfig';
import { msalInstance } from 'auth/userAccount';
import axios from 'axios';
import qs from 'qs';
import { QUERY_JOB_CUSTOMERCONTACTS, QUERY_JOB_JOBCONTACTS } from 'utils/masterData';

export async function jobSubmittalLoader({ params, queryClient }) {
  const jobId = params.jobId;

  const account = msalInstance.getAllAccounts()[0];
  const msalResponse = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: account,
  });
  const token = msalResponse.accessToken;

  //fetch the user permissions
  const permissionResponse = await axios.post(
    `submittals/${jobId}/permissions`,
    {},
    {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    }
  );

  //fetch the user permissions
  const jobSegments = (
    await axios.get(`projections/${jobId}/segments?excludeSubsegments=true`, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
  ).data;

  //fetch the customer contacts
  (await queryClient.getQueryData([...QUERY_JOB_CUSTOMERCONTACTS, jobId])) ??
    queryClient.fetchQuery({
      queryKey: [...QUERY_JOB_CUSTOMERCONTACTS, jobId],
      queryFn: async () =>
        (
          await axios.get(`fab/${jobId}/customercontacts`, {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          })
        ).data?.value,
      refetchOnMount: 'always',
    });

  //fetch the  CMC contacts
  (await queryClient.getQueryData([...QUERY_JOB_JOBCONTACTS, jobId])) ??
    queryClient.fetchQuery({
      queryKey: [...QUERY_JOB_JOBCONTACTS, jobId, 'PMG', 'DTL'],
      queryFn: async () =>
        (
          await axios.get(`fab/${jobId}/jobContacts`, {
            loaderRequired: false,
            params: { active: true, roleIds: ['PMG', 'DTL'] },
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
          })
        ).data?.value,
      refetchOnMount: 'always',
    });

  //fetching jobName and id
  const jobMainInfo = (
    await axios.get(`jobs/${jobId}/mainInfo`, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
  ).data;

  const userPermission = {
    canViewSubmittals: permissionResponse.data.canview,
    canEditSubmittal: permissionResponse.data.canEdit,
  };

  return { permissions: userPermission, jobSegments, job: jobMainInfo };
}
